export default __webpack_public_path__ + "images/abdfd4067df231733b3193557bd3f753.png";